/* unplugin-vue-components disabled */import script from "./api.vue?vue&type=script&setup=true&lang=js"
export * from "./api.vue?vue&type=script&setup=true&lang=js"

import "./api.vue?vue&type=style&index=0&id=58508672&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58508672"]])

export default __exports__